import h, { FunctionComponent } from 'preact';
import classNames from 'classnames';

const Checkout: FunctionComponent<CheckoutProps> = ({ canCheckout }) => {
    return <div class="col-3 text-right">
            <a
                href="/checkout"
                id="js-checkout-button"
                class={classNames('btn', 'btn-primary', 'basket__cta', 'mt-5', { 'disabled': !canCheckout, 'js-link-disabled': !canCheckout })}
                disabled={!canCheckout}
                aria-disabled={!canCheckout ? 'true' : 'false'}
            >
                <span>Checkout</span>
            </a>
        </div>
    ;
};

interface CheckoutProps {
    canCheckout: boolean;
}

export default Checkout;
